import React from 'react';
import { FormattedMessage } from 'react-intl';

import Link from '/src/components/LocalizedLink';
import useLocale from '../hooks/useLocale';

import imgFooterLogo from '../assets/images/footer/Logo.png';
import imgAdress from '../assets/images/footer/address.svg';
import imgPhone from '../assets/images/footer/phone-call.svg';
import imgMail from '../assets/images/footer/email-3.svg';
import ImgFacebook from '../assets/images/footer/facebook.inline.svg';
// import ImgTwitter from '../assets/images/footer/twitter.inline.svg';
import ImgInstagram from '../assets/images/footer/Instagram.inline.svg';

import IconArrowRight from '../assets/images/svg/arrow-right-red.inline.svg';

const Footer = () => {
  const { enLocale } = useLocale({ matchPathName: '/es/' });
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-xl-3 col-lg-4 col-sm-6 col-12">
            <h3 className="c-text-16 footer__subtitle">
              <FormattedMessage id="menu.company" />
            </h3>
            <FormattedMessage id={'url.about.index'}>
              {(link) => (
                <Link className="c-text-14 footer__link" to={link[0]}>
                  <FormattedMessage id={'menu.aboutUsFooter'} />
                </Link>
              )}
            </FormattedMessage>
            <FormattedMessage id={'url.about.what-is-tefl-and-how-does-it-work'}>
              {(link) => (
                <Link className="c-text-14 footer__link" to={link[0]}>
                  <FormattedMessage id={'menu.aboutTefl'} />
                </Link>
              )}
            </FormattedMessage>
            <FormattedMessage id={'url.about.team'}>
              {(link) => (
                <Link className="c-text-14 footer__link" to={link[0]}>
                  <FormattedMessage id={'menu.meetTheTeam'} />
                </Link>
              )}
            </FormattedMessage>

            <FormattedMessage id={'url.blog'}>
              {(link) => (
                <Link className="c-text-14 footer__link" to={link[0]}>
                  <FormattedMessage id={'menu.blog'} />
                </Link>
              )}
            </FormattedMessage>
            <FormattedMessage id={'url.about.graduates'}>
              {(link) => (
                <Link className="c-text-14 footer__link" to={link[0]}>
                  <FormattedMessage id={'menu.teflIberiaGraduates'} />
                </Link>
              )}
            </FormattedMessage>

            <FormattedMessage id={'url.guide-to-living-and-teaching-english-in-barcelona'}>
              {(link) => (
                <Link className="c-text-14 footer__link" to={link[0]}>
                  <FormattedMessage id={'menu.lifeInBarcelona'} />
                </Link>
              )}
            </FormattedMessage>
            {/* <FormattedMessage id={'url.guide-to-living-and-teaching-english-in-seville'}>
              {(link) => (
                <Link className="c-text-14 footer__link" to={link[0]}>
                  <FormattedMessage id={'menu.lifeInSeville'} />
                </Link>
              )}
            </FormattedMessage> */}
            <FormattedMessage id={'url.tefl-teaching-resources'}>
              {(link) => (
                <Link className="c-text-14 footer__link" to={link[0]}>
                  <FormattedMessage id={'menu.resources'} />
                </Link>
              )}
            </FormattedMessage>
            <FormattedMessage id={'url.courses.tefl-course-payment-plan'}>
              {(link) => (
                <Link className="c-text-14 footer__link" to={link[0]}>
                  <FormattedMessage id={'menu.paymentPlan'} />
                </Link>
              )}
            </FormattedMessage>

            <FormattedMessage id={'url.about.accreditation'}>
              {(link) => (
                <Link className="c-text-14 footer__link" to={link[0]}>
                  <FormattedMessage id={'menu.accreditations'} />
                </Link>
              )}
            </FormattedMessage>
            <FormattedMessage id={'url.working-as-a-teacher.work-with-us'}>
              {(link) => (
                <Link className="c-text-14 footer__link" to={link[0]}>
                  <FormattedMessage id={'menu.workWithUs'} />
                </Link>
              )}
            </FormattedMessage>
          </div>
          <div className="col-xl-3 col-lg-4 col-sm-6 col-12">
            <h3 className="c-text-16 footer__subtitle">
              <FormattedMessage id="menu.teflCourses" />
            </h3>
            {enLocale && (
              <FormattedMessage id={'url.courses.index'}>
                {(link) => (
                  <Link className="c-btn c-btn--white footer__link" to={link[0]}>
                    <FormattedMessage id={'menu.allCourses'} />
                    <IconArrowRight />
                  </Link>
                )}
              </FormattedMessage>
            )}
            <FormattedMessage id={'url.courses.one-month-160-hour-tefl-course.index'}>
              {(link) => (
                <Link className="c-text-14 footer__link" to={link[0]}>
                  <FormattedMessage id={'menu.trinityCerttesol'} />
                </Link>
              )}
            </FormattedMessage>
            {/* <FormattedMessage id={'url.courses.online-trinity-certtesol-tefl-course'}>
              {(link) => (
                <Link className="c-text-14 footer__link" to={link[0]}>
                  <FormattedMessage id={'menu.onlineTrinity'} />
                </Link>
              )}
            </FormattedMessage> */}
            <FormattedMessage id={'url.courses.developing-teacher-course'}>
              {(link) => (
                <Link className="c-text-14 footer__link" to={link[0]}>
                  <FormattedMessage id={'menu.developingTeacher'} />
                </Link>
              )}
            </FormattedMessage>
            <FormattedMessage id={'url.tefl-spanish-course-barcelona'}>
              {(link) => (
                <Link className="c-text-14 footer__link" to={link[0]}>
                  <FormattedMessage id={'menu.spanishCourses'} />
                </Link>
              )}
            </FormattedMessage>
            {/* <FormattedMessage id={'url.teaching-kids-course'}>
              {(link) => (
                <Link className="c-text-14 footer__link" to={link[0]}>
                  <FormattedMessage id={'menu.teachingYoungLearners'} />
                </Link>
              )}
            </FormattedMessage> */}

            <FormattedMessage id={'url.clases-de-ingles-economicas-barcelona.index'}>
              {(link) => (
                <Link className="c-text-14 footer__link" to={link[0]}>
                  <FormattedMessage id={'menu.classesDeIngles'} />
                </Link>
              )}
            </FormattedMessage>
            {/* <Link to="/blended-trinity-cert-tesol-course/" className="c-text-14 footer__link">
              Blended Trinity CertTESOL Course
            </Link> */}
            <FormattedMessage id={'url.courses.dates.index'}>
              {(link) => (
                <Link className="c-text-14 footer__link" to={link[0]}>
                  <FormattedMessage id={'menu.dates&fees'} />
                </Link>
              )}
            </FormattedMessage>
          </div>
          <div className="col-xl-2 col-lg-4 col-sm-6 col-12">
            <h3 className="c-text-16 footer__subtitle">
              <FormattedMessage id="menu.helpCenter" />
            </h3>
            <FormattedMessage id={'url.accommodation'}>
              {(link) => (
                <Link className="c-text-14 footer__link" to={link[0]}>
                  <FormattedMessage id={'menu.accommodation'} />
                </Link>
              )}
            </FormattedMessage>
            <FormattedMessage id={'url.working-as-a-teacher.careers-service'}>
              {(link) => (
                <Link className="c-text-14 footer__link" to={link[0]}>
                  <FormattedMessage id={'menu.carrerService'} />
                </Link>
              )}
            </FormattedMessage>
            <FormattedMessage id={'url.working-as-a-teacher.student-visas'}>
              {(link) => (
                <Link className="c-text-14 footer__link" to={link[0]}>
                  <FormattedMessage id={'menu.studentsVisas'} />
                </Link>
              )}
            </FormattedMessage>
            <FormattedMessage id={'url.courses.dates.special-offers'}>
              {(link) => (
                <Link className="c-text-14 footer__link" to={link[0]}>
                  <FormattedMessage id={'menu.specialOffers'} />
                </Link>
              )}
            </FormattedMessage>
            <FormattedMessage id={'url.covid'}>
              {(link) => (
                <Link className="c-text-14 footer__link" to={link[0]}>
                  <FormattedMessage id={'menu.covid'} />
                </Link>
              )}
            </FormattedMessage>
            <FormattedMessage id={'url.apply.how-to-make-a-good-application'}>
              {(link) => (
                <Link className="c-text-14 footer__link" to={link[0]}>
                  <FormattedMessage id={'menu.howToMakeGoodApp'} />
                </Link>
              )}
            </FormattedMessage>
            <FormattedMessage id={'url.courses.one-month-160-hour-tefl-course.entry-requirements'}>
              {(link) => (
                <Link className="c-text-14 footer__link" to={link[0]}>
                  <FormattedMessage id={'menu.entryRequirements'} />
                </Link>
              )}
            </FormattedMessage>
            <FormattedMessage id={'url.courses.faq'}>
              {(link) => (
                <Link className="c-text-14 footer__link" to={link[0]}>
                  <FormattedMessage id={'menu.faqs'} />
                </Link>
              )}
            </FormattedMessage>
            <FormattedMessage id={'url.apply.terms'}>
              {(link) => (
                <Link className="c-text-14 footer__link" to={link[0]}>
                  <FormattedMessage id={'menu.terms'} />
                </Link>
              )}
            </FormattedMessage>
            <FormattedMessage id={'url.web.privacy'}>
              {(link) => (
                <Link className="c-text-14 footer__link" to={link[0]}>
                  <FormattedMessage id={'menu.privacyPolicy'} />
                </Link>
              )}
            </FormattedMessage>
          </div>
          <div className="col-xl-4 col-lg-4 col-sm-6 col-12 order-sm-first">
            <Link to="/" className="footer__logo">
              <img src={imgFooterLogo} alt="TEFL iberia" />
            </Link>

            <a href="/#/" className="footer__info">
              <img src={imgAdress} alt="imgAdress" />
              <span className="c-text-16 info__text">
                Carrer d’Aragó 403,
                <br />
                Entresuelo 1º
                <br />
                Barcelona, 08013
                <br />
                Spain
              </span>
            </a>
            {/* <a href="/#/" className="footer__info">
              <img src={imgAdress} alt="imgAdress" />
              <span className="c-text-16 info__text">
                Calle Ardilla 10 <br /> 41010, Seville, Spain
              </span>
            </a> */}

            <a href="tel:+34 932 494 676" className="footer__info">
              <img src={imgPhone} alt="imgPhone" />
              <span className="c-text-16 info__text">+34 932 494 676</span>
            </a>
            <a href="mailto:coordination@tefl-iberia.com" className="footer__info">
              <img src={imgMail} alt="imgMail" />
              <span className="c-text-16 info__text">coordination@tefl-iberia.com</span>
            </a>

            <p className="footer__info">
              TEFL Iberia Barcelona S.L. <br />
              CIF: B10610319
            </p>
            <FormattedMessage id="url.contact.index">
              {(locale) => (
                <Link to={locale[0]} className="footer__btn c-btn c-btn--red-border">
                  <FormattedMessage id="menu.contactUs" />
                  <IconArrowRight />
                </Link>
              )}
            </FormattedMessage>

            <div className="footer__socials">
              <a
                target="_blank"
                href="https://www.facebook.com/TEFL.Iberia"
                className="socials__item"
              >
                <ImgFacebook />
              </a>
              {/* <a target="_blank" href="https://twitter.com/TEFL_Iberia" className="socials__item">
                <ImgTwitter />
              </a> */}
              <a
                target="_blank"
                href="https://www.instagram.com/tefliberia/"
                className="socials__item"
              >
                <ImgInstagram />
              </a>
            </div>
          </div>
        </div>
      </div>
      <p className="c-text-14 footer__bottom text-center">
        © 2023 All rights reserved. <br /> Partnered with{' '}
        <a href="https://www.aitoolsaver.com/" target="_blank" rel="noopener noreferrer">
          AiToolSaver
        </a>
        .
      </p>
    </footer>
  );
};

export default Footer;
